import { render, staticRenderFns } from "./CarPreview.vue?vue&type=template&id=d295336c&scoped=true"
import script from "./CarPreview.vue?vue&type=script&lang=js"
export * from "./CarPreview.vue?vue&type=script&lang=js"
import style0 from "./CarPreview.vue?vue&type=style&index=0&id=d295336c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d295336c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
